import React, { useState, useEffect, Fragment } from "react";
import styles from "./index.module.scss";
import AccessTimeIcon from "@material-ui/icons/AccessTime";
import CheckIcon from "@material-ui/icons/Check";
import { apiRequest } from "../../utils/api";
import { useNotification } from "../../context/notification";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@material-ui/core";

export default function Stepper(props) {
  const { addNotification } = useNotification();
  const { t } = useTranslation();
  const phase = [
    t("header.stepper.plan"),
    t("header.stepper.do"),
    t("header.stepper.check"),
    t("header.stepper.act"),
    "Done",
  ];

  const PD_Phase = [
    t("header.stepper.plan"),
    t("header.stepper.do"),
    t("header.stepper.act"),
    "Done",
  ];

  const [time, setTime] = useState({
    seconds: 0,
    minutes: 0,
    hours: 0,
  });

  const [activePhase] = useState(phase.indexOf(props.phase));
  const [sessionId] = useState(props.sessionId);
  const [isLoading, setIsLoading] = useState(true);
  const [sessionDurations, setSessionDurations] = useState(null);
  const [oldTotalDuration, setOldTotalDuration] = useState(null);

  //Get duration info from api
  useEffect(() => {
    setIsLoading(true);
    async function fetchData() {
      const response = await apiRequest.get(
        `/api/getSessionDurationInfo?session_id=${sessionId}`
      );

      if (response.status === 200) {
        const data = response.data.data;
        setSessionDurations(data);
      } else {
        addNotification(
          t("error.couldNotGetSession") + ` (Status code: ${response.status})`,
          "error"
        );
      }
    }
    if (sessionId) {
      fetchData();
    }
    return () => {
      setIsLoading(false);
    };
  }, [sessionId]);

  // Running Clock
  useEffect(() => {
    let isCancelled = false;
    const advanceTime = () => {
      setTimeout(() => {
        let nSeconds = time.seconds;
        let nMinutes = time.minutes;
        let nHours = time.hours;

        nSeconds++;

        if (nSeconds > 59) {
          nMinutes++;
          nSeconds = 0;
        }
        if (nMinutes > 59) {
          nHours++;
          nMinutes = 0;
        }
        if (nHours > 24) {
          nHours = 0;
        }

        !isCancelled &&
          setTime({ seconds: nSeconds, minutes: nMinutes, hours: nHours });
      }, 1000);
    };

    if (props.clockRun) advanceTime();

    return () => {
      isCancelled = true;
    };
  }, [time, props.clockRun]);

  useEffect(() => {
    const oldDuration = oldTotalDuration;
    const hms = `
    ${time.hours < 10 ? "0" + time.hours : time.hours} :
    ${time.minutes < 10 ? "0" + time.minutes : time.minutes} :
    ${time.seconds < 10 ? "0" + time.seconds : time.seconds}
  `;
    const a = hms.split(":");
    // minutes are worth 60 seconds. Hours are worth 60 minutes.
    const seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
    props.getTotalTimeSpent(seconds - oldDuration);
  }, [time]);

  //Filter Duration data based on the current phase
  useEffect(() => {
    if (sessionDurations) {
      const currentPhaseDuration = [
        ...sessionDurations.filter(
          list => list.session_phase_name === props.phaseLabel
        ),
      ];
      let time = 0;
      currentPhaseDuration.map(item => {
        time = time + item.duration;
      });
      setOldTotalDuration(time);
      const timestamp = time;
      const hours = Math.floor(timestamp / 60 / 60);
      const minutes = Math.floor(timestamp / 60) - hours * 60;
      const seconds = timestamp % 60;
      setTime({
        seconds: seconds,
        minutes: minutes,
        hours: hours,
      });
    }
  }, [sessionDurations]);

  const Clock = () => {
    return (
      <Fragment>
        {`
        ${
          time.hours === 0
            ? ""
            : time.hours < 10
              ? "0" + time.hours + ":"
              : time.hours + ":"
        }
        ${time.minutes < 10 ? "0" + time.minutes : time.minutes} :
        ${time.seconds < 10 ? "0" + time.seconds : time.seconds}
      `}
      </Fragment>
    );
  };

  return (
    <div className={styles.stepperWrapper}>
      {!props.isPDFlow && (
        <ul className={styles.stepper}>
          {phase &&
            phase.slice(0, -1).map((phaseLabel, index) => (
              <li key={index}>
                {activePhase === index && !props.isPDFlow && (
                  <div className={styles.stepperTimerActive}>
                    <div className={styles.stepperTimerIcon}>
                      <AccessTimeIcon fontSize="small" />
                    </div>
                    <Clock />
                  </div>
                )}
                {activePhase === index && props.isPDFlow && (
                  <div className={styles.stepperTimerDone}>
                    <CheckIcon fontSize="small" />
                  </div>
                )}
                {activePhase > index && (
                  <div className={styles.stepperTimerDone}>
                    <CheckIcon fontSize="small" />
                  </div>
                )}
                {activePhase < index && (
                  <div className={styles.stepperTimer}>{index + 1}</div>
                )}
                <Tooltip
                  title={phaseLabel}
                  placement="bottom"
                  PopperProps={{
                    popperOptions: {
                      modifiers: {
                        offset: {
                          enabled: true,
                          offset: "-5px, 0",
                        },
                      },
                    },
                  }}
                >
                  <span className={styles.stepperLabel}>{phaseLabel}</span>
                </Tooltip>
              </li>
            ))}
        </ul>
      )}
      {props.isPDFlow && (
        <ul className={styles.stepper}>
          {PD_Phase &&
            PD_Phase.slice(0, -1).map((phaseLabel, index) => (
              <li key={index}>
                {activePhase === index && props.isPDFlow && (
                  <div className={styles.stepperTimerActive}>
                    <div className={styles.stepperTimerIcon}>
                      <AccessTimeIcon fontSize="small" />
                    </div>
                    <Clock />
                  </div>
                )}
                {activePhase > index && (
                  <div className={styles.stepperTimerDone}>
                    <CheckIcon fontSize="small" />
                  </div>
                )}
                {activePhase < index && (
                  <div className={styles.stepperTimer}>{index + 1}</div>
                )}
                <Tooltip
                  title={phaseLabel}
                  placement="bottom"
                  PopperProps={{
                    popperOptions: {
                      modifiers: {
                        offset: {
                          enabled: true,
                          offset: "-5px, 0",
                        },
                      },
                    },
                  }}
                >
                  <span className={styles.stepperLabel}>{phaseLabel}</span>
                </Tooltip>
              </li>
            ))}
        </ul>
      )}
    </div>
  );
}
